//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () { return { tree: {}, root: null, leaves: [], dynamics: [], levelName: '' } },
  computed: {
    levelEmoji () {
      const lv = this.tree.growthLevel || 1
      return ['🌱', '🌿', '🪴', '🌳', '🌲', '🏞️'][Math.min(lv, 6) - 1]
    }
  },
  created () { this.load() },
  methods: {
    load () {
      const id = this.$route.query.id
      this.$ajax.get(this.$api.etTreeDetail + '?id=' + id).then(r => {
        this.tree = r.tree || {}; this.root = r.root; this.leaves = r.leaves || []; this.levelName = r.level_name
      })
      this.$ajax.get(this.$api.etTreeDynamics + '?id=' + id).then(r => { this.dynamics = r || [] })
    },
    invite () {
      this.$ajax.post(this.$api.etTreeInvite, { tree_id: this.tree.id }).then(r => {
        this.$toast ? this.$toast('邀请码：' + r.invite_code) : alert(r.invite_code)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/innovation/etymology-tree/detail.vue